module.exports = __webpack_public_path__ + "img/hourglass.552f4442.png";